//# sourceMappingURL=my-marked-date.interface.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/mydatepicker/dist/interfaces/my-marked-date.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-marked-date.interface.js
// module chunks = 4